import React from 'react';
import { Alert } from 'react-bootstrap';

const TLMSWarning = () => <Alert bsStyle="warning">Needs validation, TLMS updates received.</Alert>;

export default TLMSWarning;
